import { useWorkspace } from "../lib/WorkspaceContext";
import { useEngagement } from "./EngagementContext";
import { MILESTONE_COUNT } from "./milestones";
import { SparkleMark } from "./icons";

/** Passed through the shell as a slot; coaching state stays inside this module. */
export function CoachToolbarButton() {
  const { active } = useWorkspace();
  const { collapseStrip, progress } = useEngagement();
  if (!active) return null;

  const doneCount = progress?.doneCount ?? 0;

  return (
    <button type="button" className="eng-toolbar" title="Open setup card"
      aria-label="Open Simino Social setup card" onClick={() => {
        collapseStrip(false);
        requestAnimationFrame(() => {
          const board = document.getElementById("simino-coach-board");
          board?.focus({ preventScroll: true });
          board?.scrollIntoView({ block: "start", behavior: "instant" });
        });
      }}>
      <span className="eng-toolbar-badge" aria-hidden="true">
        <SparkleMark />
        <span>{doneCount}/{MILESTONE_COUNT}</span>
      </span>
      <span>Setup</span>
    </button>
  );
}
